import {Component, Input} from '@angular/core';
import {DurationPipe} from "../../pipes/duration/duration";
import {StaffServiceProvider} from "../../providers/staff-service/staff-service";
import {MyChairPage} from "../../pages/my-chair/my-chair";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";
import {Events, NavController, ViewController} from "ionic-angular";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";
import {interval} from "rxjs/observable/interval";
import {takeWhile} from "rxjs/operators";
import { BarberBookingNewPage } from '../../pages/barber-booking-new/barber-booking-new';
import { RegisterGuestServiceProvider } from '../../providers/register-guest-service/register-guest-service';

@Component({
  selector: 'staff-member',
  templateUrl: 'staff-member.html'
})
export class StaffMemberComponent {

  @Input() staff: any;
  @Input() currencySymbol: any;
  @Input() shop: any;
  @Input() isFromStafDashboard: boolean = false;
  @Input() index;
  
  loading: boolean = false;
  teamId: string;
  source: any;
  subscribe: any;
  checkInToggle: boolean = false;

  constructor(
    public navCtrl: NavController,
    public durationPipe: DurationPipe,
    public staffService: StaffServiceProvider,
    private tabsProvider: TabsServiceProvider,
    private viewCtrl: ViewController,
    private bookingProvider: BookingServiceProvider,
    private staffProvider: StaffServiceProvider,
    public events: Events,
    private registerGuestService: RegisterGuestServiceProvider
  ) {
    events.subscribe('staff:disableRefresh', () => {
      this.subscribe.unsubscribe();
    });

    events.subscribe('staff:enableRefresh', () => {
      this.refreshStaffMember();
    });
  }

  ngOnInit() {
    this.teamId = localStorage.getItem('currentTeamId');
    // this.loading = true;
    // Track todays booking service name
    if (this.staff && this.staff.todays_bookings &&  this.staff.todays_bookings.length) { this.staff.todays_bookings[0].services = this.bookingProvider.assignServices(this.staff); }
    this.checkInOutToggle();
    this.refreshStaffMember();
  }

  setStaffData(){
    return this.getStaffMemberWithBookings().then((staffMemberWithBookings) => {
      this.staff = staffMemberWithBookings;
      this.checkInOutToggle();
    });
  }

  checkInOutToggle() {
    this.checkInToggle = this.staff.current_active_team == this.teamId ? true : false;
  };

  getStaffMemberWithBookings() {
    return new Promise((resolve, reject) => {
      this.staffProvider.getStaffWithBookings(this.teamId, this.staff.id).then((staffMemberWithBookings: any) => {
        resolve(staffMemberWithBookings);
        this.loading = false;
      }).catch(error => {
        reject(error);
        this.loading = false;
      });
    })
  }

  viewQueue(staffId) {
    this.navCtrl.push(MyChairPage, {
      staffId: staffId,
      hideTabs: true
    })
  }

  queueFull(){
     if (this.staffService.isStaffQueueFull(this.staff, this.shop.id)){
       return true;
     } else {
       return false;
     }
  }

  waitTime(booking) {
    return booking.totalLength - Math.abs(booking.waitTime);
  }

  isOverrunning(booking) {
    let waitTime = this.waitTime(booking);
    if (waitTime < 0) return true;
  }

  confirmBookingCompletion (booking, staff) {
    this.events.publish('staff:disableRefresh');
    this.bookingProvider.confirmBookingCompletion(booking, staff).then((booking) => {
        return this.setStaffData().then(()=>{
          this.events.publish('staff:enableRefresh');
        });
    }).catch(error => {
      this.events.publish('staff:enableRefresh');
    })
  }

  refreshStaffMember() {
    this.source = interval(30000);

    this.subscribe = this.source
      .subscribe(() => {
        // this.setStaffData();
      });
  }

  ngOnDestroy() {
    this.subscribe.unsubscribe();
  }

  addtoQueue(navCtrl, team, barber, fromStaffPanel: boolean = false){
    this.registerGuestService.register().then(guestUser => {
      this.navCtrl.push(BarberBookingNewPage, {
        shop: this.shop,
        byStaff: true,
        barber: barber,
        guestUser: guestUser,
        fromStaffPanel: fromStaffPanel
      });
    }).catch(_ => {

    });
  }

}



// WEBPACK FOOTER //
// ./src/components/staff-member/staff-member.ts